import * as React from "react";

export default function SendEmailConfirmation() {
  return (
    <div className="message info">
      <span>{i18n["Activity.Action.Email.EmailSentMessage"]}</span>
    </div>
  );
}
